import { render } from "./OurLocation.vue?vue&type=template&id=48d3ab12&scoped=true"
import script from "./OurLocation.vue?vue&type=script&lang=js"
export * from "./OurLocation.vue?vue&type=script&lang=js"

import "./OurLocation.vue?vue&type=style&index=0&id=48d3ab12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d3ab12"]])

export default __exports__